
import DoAPICall from './DoAPICall'

export async function Login(username,password){
   return await DoAPICall({
      httpMethod:'post',
      uri:'login',
      payLoad:{
            username,
            password,
         },
      requestOptions:{}
   });
}

export async function forgotPassword(username){
   return await DoAPICall({
         httpMethod:'post',
         uri:'passwordreset',
         payLoad:{
               username
            },
         requestOptions:{}
      });
}

export async function resetPassword(username,password,resetPIN){
   return await DoAPICall({
         httpMethod:'put',
         uri:'passwordreset/'+username,
         payLoad:{
            username,
            password,
            resetPIN,
            _method:'PUT'
         },
         requestOptions:{}
      });
}